import { useIntegrationTests, TEST_STATUS } from "./aiTests";
import { Container } from "./styles";

export default () => {
  const { anyRunning, tests } = useIntegrationTests();
  const runAll = async () => {
    for (const test of tests) {
      await test.run();
    }
  };
  return (
    <Container>
      <h1>Integration Tests</h1>
      <button
        onClick={runAll}
        disabled={anyRunning}
      >
        Run All
      </button>
      <table>
        <thead>
          <tr>
            <th>Test</th>
            <th></th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {tests.map((test) => {
            return (
              <tr key={test.name}>
                <td>{test.name}</td>
                <td>
                  <button
                    className="test-run-button"
                    onClick={test.run}
                  >
                    Run Manually
                  </button>
                </td>
                <td>
                  {test.status === TEST_STATUS.notRun && "Not Run"}
                  {test.status === TEST_STATUS.running && "Running..."}
                  {test.status === TEST_STATUS.success && "Success!"}
                  {test.status === TEST_STATUS.error && "Error!"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Container>
  );
};
